module.exports = __webpack_public_path__ + "img/technology.30eb3507.svg";